const MODES = {
  tunes: {
    item: 'tune', items: 'tunes', Item: 'Tune', Items: 'Tunes',
    collection: 'set', collections: 'sets', Collection: 'Set', Collections: 'Sets',
    navSearch: 'AllMyTunes', navSets: 'AllMySets', navSessions: 'AllMySessions',
    addPageTitle: 'Add Tune',
    addButton: 'Add Tune', editButton: 'Edit Tune', randomButton: 'Random Tune',
    randomCollection: 'Random Set',
    defaultTypes: ['Jig', 'Reel', 'Hornpipe', 'Waltz', 'Polka', 'Song'],
    defaultGenres: ['Irish', 'Old-Time', 'Bluegrass'],
    defaultGenre: 'Irish',
    defaultType: '',
    statusOptions: ['Status (\u2014)', 'Need to Learn', 'Learning', 'Learned'],
    autoHideFields: [],
    customizeTitle: 'Customize Add Tune Page',
    genreLabel: 'Genre',
    genreLabelPlural: 'Genres',
    typeLabel: 'Tune Type',
    hideSearchTools: false,
    hideKeyFilter: false,
    newCollection: '+ New Set',
    collectionDescription: 'like a setlist, a practice group, or tunes for a particular session',
    sessionDescription: 'log what you played and when',
    sessionLocationHint: '"Tuesday session at the pub"',
    sessionHistoryLabel: 'a record of your playing activity',
    statusHint: 'Track your learning progress',
    socialItemsLabel: 'tunes',
    socialUserLabel: 'musicians',
  },
  notes: {
    item: 'note', items: 'notes', Item: 'Note', Items: 'Notes',
    collection: 'folder', collections: 'folders', Collection: 'Folder', Collections: 'Folders',
    navSearch: 'AllMyNotes', navSets: 'AllMyFolders', navSessions: 'AllMySessions',
    addPageTitle: 'Add Note',
    addButton: 'Add Note', editButton: 'Edit Note', randomButton: 'Random Note',
    randomCollection: 'Random Folder',
    defaultTypes: ['Note', 'Link', 'File', 'Audio', 'Idea', 'Reference', 'Task'],
    defaultGenres: ['General', 'Work', 'Personal', 'Family'],
    defaultGenre: 'General',
    defaultType: 'Note',
    statusOptions: ['Status (\u2014)', 'ASAP', 'To Do', 'In Progress', 'Done'],
    autoHideFields: ['key', 'composer', 'lyrics'],
    customizeTitle: 'Customize Add Note Page',
    genreLabel: 'Category',
    genreLabelPlural: 'Categories',
    typeLabel: 'Type',
    hideSearchTools: true,
    hideKeyFilter: true,
    newCollection: '+ New Folder',
    collectionDescription: 'like a project, a topic, or a set of related ideas',
    sessionDescription: 'log your writing or practice sessions',
    sessionLocationHint: '"Morning writing", "Project: March"',
    sessionHistoryLabel: 'a record of your activity over time',
    statusHint: 'Track your to-do status',
    socialItemsLabel: 'notes',
    socialUserLabel: 'people',
  },
  all: {
    item: 'item', items: 'items', Item: 'Item', Items: 'Items',
    collection: 'collection', collections: 'collections', Collection: 'Collection', Collections: 'Collections',
    navSearch: 'AllMyItems', navSets: 'AllMyCollections', navSessions: 'AllMySessions',
    addPageTitle: 'Add Item',
    addButton: 'Add Item', editButton: 'Edit Item', randomButton: 'Random Item',
    randomCollection: 'Random Collection',
    defaultTypes: ['Jig', 'Reel', 'Hornpipe', 'Waltz', 'Polka', 'Song', 'Note', 'Link', 'File', 'Audio', 'Idea', 'Reference', 'Task'],
    defaultGenres: ['Irish', 'Old-Time', 'Bluegrass', 'General'],
    defaultGenre: '',
    defaultType: '',
    statusOptions: ['Status (\u2014)', 'Need to Learn', 'Learning', 'Learned', 'ASAP', 'To Do', 'In Progress', 'Done'],
    autoHideFields: [],
    customizeTitle: 'Customize Add Page',
    genreLabel: 'Genre',
    genreLabelPlural: 'Genres',
    typeLabel: 'Type',
    hideSearchTools: false,
    hideKeyFilter: false,
    newCollection: '+ New Collection',
    collectionDescription: 'like a setlist, a project, or items you want to group together',
    sessionDescription: 'log what you worked on and when',
    sessionLocationHint: '"Tuesday session at the pub"',
    sessionHistoryLabel: 'a record of your activity',
    statusHint: 'Track your progress or to-do status',
    socialItemsLabel: 'tunes and notes',
    socialUserLabel: 'musicians',
  }
};

export function getModeLabels(mode) {
  return MODES[mode] || MODES.tunes;
}

export function resolveModeForEntity(appMode, entityMode = 'tunes') {
  if (!appMode) return 'tunes';
  if (appMode === 'all') return entityMode || 'tunes';
  return appMode;
}

export function getModeLabelsForEntity(appMode, entityMode = 'tunes') {
  return getModeLabels(resolveModeForEntity(appMode, entityMode));
}
